__turbopack_context__.v({
  "chart": "ChordGraphPlaceholder-module__IcLL-W__chart",
  "island": "ChordGraphPlaceholder-module__IcLL-W__island",
  "placeholder": "ChordGraphPlaceholder-module__IcLL-W__placeholder",
  "placeholderImage": "ChordGraphPlaceholder-module__IcLL-W__placeholderImage",
});
